import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plaque-type",
  "use": "plaque-type-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plaque-type\">\n<circle cx=\"6.49995\" cy=\"6.5\" r=\"6.5\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol